'use client';

import { forwardRef, useId, useState } from 'react';
import { Icon } from '../icons';
import { cn } from '../../lib/utils';
import { Input, type InputProps } from './Input';

export type PasswordInputProps = Omit<InputProps, 'type'>;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  function PasswordInput(
    {
      className,
      id: idProp,
      inputSize,
      invalid,
      fullWidth = true,
      ...props
    },
    ref,
  ) {
    const [visible, setVisible] = useState(false);
    const autoId = useId();
    const id = idProp ?? autoId;

    return (
      <div className={cn('relative', fullWidth && 'w-full')}>
        <Input
          ref={ref}
          id={id}
          type={visible ? 'text' : 'password'}
          inputSize={inputSize}
          invalid={invalid}
          fullWidth={fullWidth}
          className={cn('pr-10', className)}
          {...props}
        />
        <button
          type='button'
          className='absolute inset-y-0 right-0 flex w-10 items-center justify-center rounded-r-xl text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600'
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Hide password' : 'Show password'}
          aria-controls={id}
          aria-pressed={visible}
          tabIndex={0}
        >
          {visible ? (
            <Icon name='eye-off-outline' className='size-5' />
          ) : (
            <Icon name='eye-outline' className='size-5' />
          )}
        </button>
      </div>
    );
  },
);
